// ui/components/CapacitacionesTable.jsx  (presentacional: props in, callbacks out; sin efectos ni Api)
import React from 'react';
import NoPagination from '../../../../../components/pagination/noPagination.jsx';
import getBackgroundColor from '../../../../../utils/getBackgroundColor.js';
import getColor from '../../../../../utils/getColor.js';
import { editLinkCell, selectionColumn } from '../../../shared/ui/listColumns.jsx';

const CapacitacionesTable = ({ data, blocking, selectedUuid, onSelect, detailPath }) => {
  const columns = React.useMemo(
    () => [
      {
        // Un único grupo: NoPagination pinta la barra de título oscura y la fila de encabezados beige.
        Header: 'CAPACITACIONES',
        columns: [
          selectionColumn({ selectedUuid, onSelect }),
          { Header: 'FECHA', accessor: 'fecha', sortable: true, minWidth: 110 },
          { Header: 'NOMBRE', accessor: 'nombre_capacitacion', sortable: true, Cell: editLinkCell(detailPath) },
          { Header: 'MUNICIPIO', accessor: 'municipio_nombre', sortable: true },
          { Header: 'LOCALIDAD', accessor: 'localidad_nombre', sortable: true },
          { Header: 'NÚMERO DE ASISTENTES', accessor: 'asistentes_count', sortable: true },
          { Header: 'RESPONSABLE', accessor: 'responsable', sortable: true },
          { Header: 'ACTIVIDAD', accessor: 'actividad_nombre', sortable: true },
        ],
      },
    ],
    [selectedUuid, onSelect, detailPath]
  );

  return <NoPagination blocking={blocking} columns={columns} data={data} fnBackgroundColor={getBackgroundColor} fnColor={getColor} />;
};

export default CapacitacionesTable;
